<template>
  <div>
    <v-text-field
      v-model="dynamicSearch"
      append-outer-icon="mdi-magnify"
      clearable
      label="Search"
      type="text"
      @click:append-outer="sendSearch"
      @keydown.enter="sendSearch"
      hide-details="auto"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  data() { return{
    dynamicSearch:"",
    };
  },
  computed: {
    disableSearch(){
      return this.$route.name === "DynamicSearch" ? true : false;
    }
  },
  methods: {
    sendSearch() {
      this.$store.commit('dynamicSearch', this.dynamicSearch);
      if (this.$route.name !== "DynamicSearch") {
        this.$router.push({
          name: "DynamicSearch",
          params: { dynamicSearchInput: this.dynamicSearch } 
        });
      }
    },
  },
};
</script>